import { Theme, Components } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiPickersDay: Components<Theme>['MuiPickersDay'] = {
  styleOverrides: {
    root: {
      '&:hover, &:focus': {
        backgroundColor: scssVariables.ColorBlue10,
      },
      '&.Mui-selected': {
        backgroundColor: scssVariables.ColorBlue80,
        color: scssVariables.ColorBlack00,
        '&:hover': {
          backgroundColor: scssVariables.ColorBlue100,
        },
        '&:focus:not(:hover)': {
          backgroundColor: scssVariables.ColorBlue80,
        },
      },
    },
    today: {
      '&:not(.Mui-selected)': {
        borderWidth: '2px',
      },
    },
  },
};
